<template>
  <v-chart :option="option" autoresize style="width:100%;height:260px;" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import VChart from 'vue-echarts';
import { useChartTheme } from '@/composables/useChartTheme';

const props = defineProps<{ soh: number; label: string }>();

const option = computed(() => {
  const C = useChartTheme();
  return {
    backgroundColor: C.paper,
    series: [{
      type: 'gauge',
      startAngle: 210,
      endAngle: -30,
      min: 60,
      max: 100,
      splitNumber: 4,
      radius: '88%',
      center: ['50%', '56%'],
      axisLine: {
        lineStyle: {
          width: 20,
          color: [
            [0.25,  C.bad],
            [0.625, C.warn],
            [1,     C.good],
          ],
        },
      },
      pointer: { length: '68%', width: 5, itemStyle: { color: C.ink } },
      axisTick:  { splitNumber: 5, lineStyle: { width: 1, color: 'rgba(255,255,255,0.25)' } },
      splitLine: { length: 10, lineStyle: { width: 2, color: 'rgba(255,255,255,0.35)' } },
      axisLabel: {
        distance: 26,
        color: C.muted,
        fontSize: 11,
        fontFamily: 'Inter, system-ui, sans-serif',
        formatter: '{value}%',
      },
      detail: {
        valueAnimation: false,
        formatter: '{value}%',
        color: C.ink,
        fontSize: 28,
        fontWeight: 700,
        fontFamily: 'Inter, system-ui, sans-serif',
        offsetCenter: [0, '48%'],
      },
      title: {
        offsetCenter: [0, '70%'],
        color: C.muted,
        fontSize: 12,
        fontFamily: 'Inter, system-ui, sans-serif',
      },
      data: [{ value: props.soh, name: props.label }],
    }],
  };
});
</script>
